import { useLazyQuery } from '@apollo/client';
import { GET_ANIMALS_PER_TRAINS } from 'store/queries';
import { getAvailableTrainsForJourney } from 'pages/JourneySearch/JourneySearch.utils';

const useAnimalsPerTrainsQuery = () => {
  const [fetchOutbound, { loading: outboundLoading, data: outbound }] = useLazyQuery(GET_ANIMALS_PER_TRAINS, {
    fetchPolicy: 'network-only'
  });
  const [fetchInbound, { loading: inboundLoading, data: inbound }] = useLazyQuery(GET_ANIMALS_PER_TRAINS, { fetchPolicy: 'network-only' });

  const handleQueries = async ({ variables: { outboundDate, inboundDate, search, hasDogs = false } }) => {
    if (!hasDogs) return;

    if (outboundDate) {
      const outboundTrains = getAvailableTrainsForJourney({ travels: search.outbound.journeys });
      await fetchOutbound({
        variables: {
          trainNumbers: outboundTrains,
          departureDate: outboundDate
        }
      });
    }

    if (inboundDate) {
      const inboundTrains = getAvailableTrainsForJourney({ travels: search.inbound.journeys });
      await fetchInbound({
        variables: {
          trainNumbers: inboundTrains,
          departureDate: inboundDate
        }
      });
    }
  };

  return [
    handleQueries,
    {
      data: { outbound: outbound?.getAnimalsPerTrains ?? [], inbound: inbound?.getAnimalsPerTrains ?? [] },
      loading: { outbound: outboundLoading, inbound: inboundLoading }
    }
  ];
};

export default useAnimalsPerTrainsQuery;
